import React from 'react';

const Unauthorized = () => {
  return (
    <div>
      <h2>401 - Acceso no autorizado</h2>
      <p>No tienes permisos para acceder a esta página.</p>
    </div>
  );
};

export default Unauthorized;